module.exports = __webpack_public_path__ + "img/TIV_nettkurs_logo.f1ffaad4.png";